/** @file zoomViewport: zooms the Pose viewport one integer step by sending it the wheel tick a mouse would. */
import { viewportCanvas } from './viewportCanvas';

/** `in` = wheel up; the viewport's own wheel rule does the zoom (1..8). Returns whether a viewport took it. */
export function zoomViewport(direction: 'in' | 'out'): boolean {
  const canvas = viewportCanvas();
  if (canvas === null) return false;
  canvas.dispatchEvent(new WheelEvent('wheel', { deltaY: direction === 'in' ? -100 : 100, bubbles: true, cancelable: true }));
  return true;
}
